import React, { useState } from 'react'
import NoData from '../../../global/ui/NoData';
import DraggableItem from '../../../global/DraggableItem';
import { showToast } from '../../../utils';
import LocationTag from '../scouting/LocationTag';

const img = 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=280&fit=crop'

const LocationVaultGridView = (props: any) => {

    const [openMenuId, setOpenMenuId] = useState<number | null>(null);

    const allData = props?.allLocationData?.length > 0 ? props?.allLocationData : [];

    if (allData?.length <= 0) {
        return (
            <NoData message='No location information available.' />
        )
    }

    return (
        <div className={`lv-grid`}>
            {allData?.map((item: any, index: any) => {
                const loc = item?.location;
                return (
                    <DraggableItem
                        key={loc?.id}
                        index={index}
                        moveItem={props?.moveItem}
                        className="lv-card"
                        onClick={() => {
                            if (openMenuId) {
                                setOpenMenuId(null)
                                return
                            }
                            props?.onImageView?.(item)
                        }}
                        itemId={item?.id}
                        renderType='vault'
                        data={item}
                    >
                        {(props?.isScouted && loc?.scouting_tags) &&
                            <div className='tag--overlay'>
                                <LocationTag variant={loc?.scouting_tags} />
                            </div>
                        }
                        <img
                            src={loc?.thumbnail || '/assets/images/yellow-6th.png'}
                            alt={loc.name}
                            className="lv-card__img"
                        />
                        <div className="lv-card__overlay">
                            <div onClick={(e) => {
                                e.stopPropagation();
                                props?.onView?.(item)
                            }}
                                className="lv-card__info"
                            >
                                <span className="lv-card__name">{loc?.name}</span>
                                <span className="lv-card__city">{loc?.address}</span>
                            </div>
                            {item?.role != 'V' &&
                                <div className="lv-card__menu-wrap">
                                    <button
                                        className="lv-card__menu-btn"
                                        onClick={e => {
                                            e.stopPropagation();
                                            setOpenMenuId(openMenuId === loc.id ? null : loc.id);
                                        }}
                                    >
                                        <img src='/assets/images/dots-vertical-rounded.svg' alt='more' />
                                    </button>
                                    {openMenuId === loc.id && (
                                        <div className="lv-card__menu-dropdown">
                                            {!props?.hideAsign &&
                                                <>
                                                    <button onClick={() => {
                                                        setOpenMenuId(null)
                                                        props?.onAsign(item)
                                                    }}
                                                        className="lv-card__menu-item">
                                                        <img src='/assets/images/plus-icon-1.svg' />
                                                        {props?.vaultType == 'myvault' ? 'Add to production' : 'Assign Location'}
                                                    </button>
                                                    {props?.vaultType != 'myvault' &&
                                                        <button
                                                            onClick={() => {
                                                                setOpenMenuId(null)
                                                                props?.onScriptAsign(item)
                                                            }}
                                                            className="lv-card__menu-item">
                                                            <img src='/assets/images/perscript-active.svg' />
                                                            Assign to script
                                                        </button>
                                                    }
                                                </>
                                            }
                                            {props?.vaultType == 'myvault'
                                                ?
                                                null
                                                :
                                                <button
                                                    onClick={() => {
                                                        setOpenMenuId(null)
                                                        props?.onShare?.(item)
                                                    }}
                                                    className="lv-card__menu-item"
                                                >
                                                    <img src='/assets/images/share-blue.svg' />
                                                    Share
                                                </button>
                                            }
                                            {!props?.isScouted &&
                                                <button
                                                    className="lv-card__menu-item"
                                                    onClick={() => {
                                                        props?.onDelete(item)
                                                        setOpenMenuId(null)
                                                    }}
                                                >
                                                    <img src='/assets/images/Delete-icon-red.svg' />
                                                    Delete
                                                </button>
                                            }
                                        </div>
                                    )}
                                </div>
                            }
                        </div>
                    </DraggableItem>
                )
            })}
        </div>
    )
}

export default LocationVaultGridView